import Alert from 'common/components/alert/Alert';
import { isActionCompleteFail } from 'common/services/api/isActionCompleteFail';
import { isActionCompleteSuccess } from 'common/services/api/isActionCompleteSuccess';
import AlertType from 'common/types/AlertType';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import React from 'react';
import { Button, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { AccountSecurityForm } from './AccountSecurityForm';

interface IAccountSecurityPresenter {
  email: string;
  response: ActionCompleteResponse | null;
  onSubmit: (values: AccountSecurityForm) => void;
  submitting: boolean;
}

const AccountSecurityPresenter = (props: IAccountSecurityPresenter) => {
  return (
    <>
      {isActionCompleteFail(props.response) && (
        <Alert type={AlertType.danger}>
          <ul>
            {props.response.payload.errorInfo?.errorItems?.map(
              (error, i = 0) => (
                <li key={i++}>{error}</li>
              )
            )}
          </ul>
        </Alert>
      )}
      {isActionCompleteSuccess(props.response) && (
        <Alert type={AlertType.success}>Password updated successfully</Alert>
      )}
      <Form<AccountSecurityForm> onSubmit={props.onSubmit}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel htmlFor='email'>Email</FormLabel>
              <FormControl disabled id='email' value={props.email} />
            </FormGroup>
            <Field name='currentPassword' type='password'>
              {({ input }) => (
                <FormGroup>
                  <FormLabel htmlFor='currentPassword'>
                    Current Password
                  </FormLabel>
                  <FormControl id='currentPassword' {...input} />
                </FormGroup>
              )}
            </Field>
            <Field name='newPassword' type='password'>
              {({ input }) => (
                <FormGroup>
                  <FormLabel htmlFor='newPassword'>New Password</FormLabel>
                  <FormControl id='newPassword' {...input} />
                </FormGroup>
              )}
            </Field>

            <Button type='submit' variant='primary' disabled={props.submitting}>
              Submit
            </Button>
          </form>
        )}
      </Form>
    </>
  );
};

export default AccountSecurityPresenter;
